export default __webpack_public_path__ + "static/media/bookGreen.1fa9be45.svg";